<div class="rating">
    <div class="ratingOver"></div>
    <div>Cliente Perfil {{ perfil }}</div>
    <div>
        <ng-rating-bar 
            [value]="valor" 
            [ratingCount]="5"
            [disabled]="true">
        </ng-rating-bar>
    </div>
</div>